export default [
  {
    path: '/onboarding',
    component: () => import(/* webpackChunkName: "onboarding" */ '@/layouts/Onboarding.vue'),
    children: [
      {
        name: 'OnboardingCompany',
        path: 'company',
        component: () => import(/* webpackChunkName: "onboarding" */ '@/views/onboarding/OnboardingCompany.vue')
      },
      {
        name: 'OnboardingBrand',
        path: 'brand',
        component: () => import(/* webpackChunkName: "onboarding" */ '@/views/onboarding/OnboardingBrand.vue')
      },
    ]
  },
  {
    path: '/onboarding/:account',
    component: () => import(/* webpackChunkName: "onboarding" */ '@/layouts/Onboarding.vue'),
    children: [
      {
        name: 'OnboardingIntegrations',
        path: 'integrations',
        component: () => import(/* webpackChunkName: "onboarding" */ '@/views/onboarding/OnboardingIntegrations.vue')
      }
    ]
  }
]